export default defineNuxtRouteMiddleware((to) => {
  // Enforce no trailing slash (except root) to avoid duplicate routes.
  if (to.path === '/' || !to.path.endsWith('/')) return
  if (to.path.includes('.')) return

  return navigateTo(
    { path: to.path.slice(0, -1) || '/', query: to.query, hash: to.hash },
    { replace: true },
  )
})
